import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ISelectBuilder from "../../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import IUserSelectorBuilder from "../../../../toolkit/baseForms2Commons/iUserSelectorBuilder/IUserSelectorBuilder";

const mesesOpts = [
  { value: "01", label: "Enero" },
  { value: "02", label: "Febrero" },
  { value: "03", label: "Marzo" },
  { value: "04", label: "Abril" },
  { value: "05", label: "Mayo" },
  { value: "06", label: "Junio" },
  { value: "07", label: "Julio" },
  { value: "08", label: "Agosto" },
  { value: "09", label: "Septiembre" },
  { value: "10", label: "Octubre" },
  { value: "11", label: "Noviembre" },
  { value: "12", label: "Diciembre" }
];

const now = new Date();
const currentYear = now.getFullYear();
const currentMonth = String(now.getMonth() + 1).padStart(2, "0");
const aniosOpts = [
  { label: currentYear, value: currentYear },
  { label: currentYear - 1, value: currentYear - 1 },
  { label: currentYear - 2, value: currentYear - 2 }
];

export type Inputs = "mes" | "anio" | "idVendedor";
export type Buttons = "buscar";

/** Valores iniciales del formulario (mes/año en curso). Usar en FormBuilder `init`. */
export const defaultFiltros: Partial<{ [key in Inputs]: any }> = {
  mes: currentMonth,
  anio: currentYear
};

/**
 * REPORTE GENERAL DE VENDEDORES — Filtros
 * Pantalla: /reportes/reporte-general-vendedor
 *
 * - Mes: obligatorio; por defecto el mes en curso.
 * - Año: opcional (default año actual).
 * - Vendedor: solo si canFilterBySeller (permiso 57000); entonces es obligatorio.
 * Sin permiso 57000 el backend resuelve al usuario de sesión.
 */
export function buildFormConfig(
  canFilterBySeller: boolean
): FormBuilderConfig<Inputs, Buttons> {
  return {
    inputs: [
      {
        name: "mes",
        label: "* Mes",
        bts: { mCol: 2 },
        component: ISelectBuilder,
        props: {
          emptyLabel: "Seleccione",
          data: mesesOpts
        }
      },
      {
        name: "anio",
        label: "Año",
        bts: { mCol: 2 },
        component: ISelectBuilder,
        props: {
          emptyLabel: currentYear.toString(),
          data: aniosOpts
        }
      },
      {
        name: "idVendedor",
        label: "* Vendedor",
        bts: { mCol: 4 },
        component: IUserSelectorBuilder,
        props: {
          // Backend filtra por auth user_id (ej. 10784), NO por número de empleado
          hidden: () => !canFilterBySeller,
          useNumeroEmpleado: false,
          useNombreEmpleado: false
        }
      }
    ],
    buttons: [
      {
        name: "buscar",
        label: "Buscar",
        isSubmit: true,
        bts: { mCol: 2 },
        component: IButtonBuilder
      }
    ],
    validations: {
      mes: {
        required: true
      },
      ...(canFilterBySeller
        ? {
            idVendedor: {
              required: true
            }
          }
        : {})
    },
    rows: [["mes", "anio", "idVendedor", "buscar"]]
  };
}
